import { render, staticRenderFns } from "./ResellersList.vue?vue&type=template&id=62cd634f&scoped=true&"
import script from "./ResellersList.vue?vue&type=script&lang=js&"
export * from "./ResellersList.vue?vue&type=script&lang=js&"
import style0 from "./ResellersList.vue?vue&type=style&index=0&id=62cd634f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd634f",
  null
  
)

component.options.__file = "ResellersList.vue"
export default component.exports